import React from 'react';
import Modal from '@mui/material/Modal';
import { Box } from '@mui/material';

import themeColors from '../../../../shared/components/ThemeColors/ThemeColors';
import ModeGraphicModalContent from './ModeGraphicModalContent';
import ModeGraphicModalHeader from './ModeGraphicModalHeader';
import useModeGraphicModalController from './hooks/useModeGraphicModalController';

const ModeGraphicModal = ({ open, onClose, data, loading, setLoading }) => {
  const {
    tableColumns,
    campaignsSummaryData,
    excelTableRows,
    excelTableColumns,
    showNewTable,
    loadingTable,
    page,
    setPage,
    totalItems,
    startDate,
    setStartDate,
    endDate,
    setEndDate,
    loadingLabels,
    loadingExcel,
    loadingSearch,
    sentMessagesLength,
    setSentMessagesLength,
    totalApiPages,
    setTotalApiPages,
    rowsPerPage,
    downloadExcel,
    searchCampaigns,
    fetchDataToNewTable,
    openCampaignAnalysis,
    dynamicTableCampaignName,
    setShowNewTable,
    setExcelTableRows,
    setExcelTableColumns,
  } = useModeGraphicModalController({ open, data, setLoading });

  return (
    <Modal open={open} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <Box
        sx={{
          width: '100%',
          height: '100%',
          display: 'flex',
          backgroundColor: '#F4F5FF',
          borderRadius: '0px',
          zIndex: 5000,
          position: 'relative',
          padding: { xs: '20px', sm: showNewTable && loadingTable === false ? '70px 30px 0px 30px' : '30px' },
          overflow: 'auto',
          scrollbarWidth: 'thin',
          scrollbarColor: `${themeColors.gray30} ${themeColors.gray10}`,
        }}
      >
        <ModeGraphicModalHeader
          excelColumns={excelTableColumns}
          resetModal={onClose}
          rows={excelTableRows}
          setShowNewTable={setShowNewTable}
          showNewTable={showNewTable}
          loadingTable={loadingTable}
        />

        <ModeGraphicModalContent
          sentMessagesLength={sentMessagesLength}
          setSentMessagesLength={setSentMessagesLength}
          setEndDate={setEndDate}
          startDate={startDate}
          endDate={endDate}
          setStartDate={setStartDate}
          downloadExcel={downloadExcel}
          loadingExcel={loadingExcel}
          loadingLabels={loadingLabels}
          searchCampaigns={searchCampaigns}
          loadingSearch={loadingSearch}
          fetchDataToNewTable={fetchDataToNewTable}
          openCampaignAnalysis={openCampaignAnalysis}
          loadingTable={loadingTable}
          showNewTable={showNewTable}
          excelColumns={excelTableColumns}
          rows={excelTableRows}
          setRows={setExcelTableRows}
          columns={tableColumns}
          setExcelColumns={setExcelTableColumns}
          campaigns={campaignsSummaryData}
          loading={loading}
          page={page}
          setPage={setPage}
          rowsPerPage={rowsPerPage}
          totalItems={totalItems}
          themeColors={themeColors}
          totalApiPages={totalApiPages}
          setTotalApiPages={setTotalApiPages}
          dynamicTableCampaignName={dynamicTableCampaignName}
        />
      </Box>
    </Modal>
  );
};

export default ModeGraphicModal;
